module.exports = __webpack_public_path__ + "static/media/qan-modal-graphic.70a0aa0e.svg";